const FORBIDDEN_TAGS = ["script", "iframe", "object", "embed", "form", "base"];

const JS_PROTO = ["j", "a", "v", "a", "s", "c", "r", "i", "p", "t", ":"].join(
  "",
);

function sanitizeHtml(dirty: string): string {
  const doc = new DOMParser().parseFromString(dirty, "text/html");

  FORBIDDEN_TAGS.forEach((tag) => {
    doc.querySelectorAll(tag).forEach((el) => el.remove());
  });

  doc.querySelectorAll("*").forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const val = attr.value.trimStart().toLowerCase();
      if (
        attr.name.startsWith("on") ||
        ((attr.name === "href" || attr.name === "src") &&
          val.startsWith(JS_PROTO))
      ) {
        el.removeAttribute(attr.name);
      }
    });
  });

  return doc.body.innerHTML;
}

export default sanitizeHtml;